export const SECTOR_PERFORMANCE = "SECTOR_PERFORMANCE";
export const SECTOR_PERFORMANCE_ERROR = "SECTOR_PERFORMANCE_ERROR";
export const SECTOR_PERFORMANCE_HIDE_ERROR = "SECTOR_PERFORMANCE_HIDE_ERROR";
export const SECTOR_START_LOADER = "SECTOR_START_LOADER";
export const SECTOR_STOP_LOADER = "SECTOR_STOP_LOADER";
export const SECTOR_PERFORMANCE_STREAM = "SECTOR_PERFORMANCE_STREAM";
